module.exports = __webpack_public_path__ + "logo-2807c89d296f6dfcc0079750d6b0059e.png";